/**
 * Authentication not authenticated component
 * Displays message when user is not authenticated with link to external auth page
 */

import {
	Button,
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@medme/ui"
import { cn } from "@medme/ui/lib"

export interface AuthNotAuthenticatedProps {
	/** Message to display */
	title: string
	message: string
	/** External authorization URL (ignored when onAuthClick is set) */
	authUrl: string
	/** Button text */
	buttonText: string
	/** Override default navigation — used for MSW mock login */
	onAuthClick?: () => void
	className?: string
}

/**
 * Component that displays message when user is not authenticated
 * Provides link to external authorization page
 */
export function AuthNotAuthenticated({
	title,
	message,
	authUrl,
	buttonText,
	onAuthClick,
	className,
}: AuthNotAuthenticatedProps) {
	const handleAuthClick = () => {
		if (onAuthClick) {
			onAuthClick()
			return
		}
		if (typeof window !== "undefined" && authUrl) {
			window.location.href = authUrl
		}
	}

	const canAuth = Boolean(onAuthClick || authUrl)

	return (
		<div
			className={cn(
				"min-h-screen flex items-center justify-center bg-background p-4",
				className,
			)}
		>
			<Card className="w-full max-w-md">
				<CardHeader>
					<CardTitle>{title}</CardTitle>
					<CardDescription>{message}</CardDescription>
				</CardHeader>
				<CardContent>
					<Button
						onClick={handleAuthClick}
						variant="default"
						className="w-full"
						disabled={!canAuth}
					>
						{buttonText}
					</Button>
				</CardContent>
			</Card>
		</div>
	)
}
